import React from 'react';
import ReactDOM from 'react-dom';
import { StoreProvider } from 'easy-peasy';
import { ThemeProvider } from 'emotion-theming';
import getTheme from '~/css-in-js/theme';

import config from '~/config/article';
import DataStore from '~/scripts/store';

const theme = getTheme('light');

export function getIsEmbed() {
  return !!process.env.IS_EMBED;
}

export function getFilterFn(filter) {
  if (filter === 'germany') {
    return (d) => d.parent === 'de';
  }

  if (filter === 'europe') {
    return (d) => config.europeIds.indexOf(d.id) >= 0;
  }

  if (filter === 'world') {
    return (d) => d.levels.includes(0);
  }

  return (d) => d.parent === 'null';
}

export function getMapFilterFn(filter) {
  if (filter === 'germany') {
    return (d) => d.levels.includes(1);
  }

  return (d) => d.levels.includes(0);
}

export function withStore(Component, props = {}) {
  return (addProps) => (
    <StoreProvider store={DataStore}>
      <ThemeProvider theme={theme}>
        <Component {...props} {...addProps} />
      </ThemeProvider>
    </StoreProvider>
  );
}

export function renderReactComponent(elementId, Component, props = {}, wrapStore = true) {
  const element = document.getElementById(elementId);

  if (element) {
    const WrappedComponent = wrapStore ? withStore(Component, props) : Component;
    ReactDOM.render(<WrappedComponent />, element);
  }
}

export default {
  renderReactComponent,
};
